import { render, staticRenderFns } from "./StatisticsView.vue?vue&type=template&id=f134c9d0&scoped=true&"
import script from "./StatisticsView.vue?vue&type=script&lang=js&"
export * from "./StatisticsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f134c9d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
